const REAL_LIST_VALUES = {
    beautyCarousel: 'Beauty carousel',
    beautyBestSellerCarousel: 'beauty-bestseller-carousel',
    frontPageCarousel: 'Frontpage carousel',
    relativeProducts: 'Relative',
    productSeriesWidget: 'Product series widget',
    shadeFinder: 'Shade finder',
    wishlist: 'Wishlist',
    helperWidget: 'Helper widget',
    recentlyViewed: 'Recently viewed',
    directTraffic: 'Direct traffic to product detail',
    collection: 'collection',
    sharedCollection: 'shared-collection',
    bestsellers: 'bestsellers',
    searchResultPage: 'search_result_page',
    search: 'search'
};

export default REAL_LIST_VALUES;
